// extracted by mini-css-extract-plugin
module.exports = {"container":"artist_container__CWxd9","wrapper":"artist_wrapper__2C-Rb"};